import { CalendarDays, Dumbbell, History, ListChecks, Plus } from 'lucide-react';
import { lazyComponent } from '@/platform/lazyComponent';
import type { PlatformModule } from '@/platform/modules';
import { athleteTrainingRoutes, trainingRoutes } from './routes';

const CoachTrainingCard = lazyComponent(() => import('./CoachTrainingCard').then((m) => m.CoachTrainingCard));

export const trainersModule: PlatformModule = {
  id: 'trainers',
  nav: [{
    id: 'training', label: 'Training', to: '/training', icon: Dumbbell, permission: 'training.view', section: 'main', order: 25, parentId: 'coach',
    children: [
      { id: 'training-overview', label: 'Overview', to: '/training', icon: ListChecks, permission: 'training.view', section: 'main', order: 10 },
      { id: 'training-calendar', label: 'Calendar', to: '/training?view=calendar', icon: CalendarDays, permission: 'training.view', section: 'main', order: 20 },
      { id: 'training-history', label: 'History', to: '/training?view=history', icon: History, permission: 'training.view', section: 'main', order: 30 },
    ],
  }],
  routes: trainingRoutes,
  routeExtensions: { athlete: athleteTrainingRoutes },
  athleteTabs: [{ id: 'training', label: 'Training', path: 'training', permission: 'training.view', order: 75, icon: Dumbbell }],
  quickActions: [{ id: 'new-training', label: 'Training session', icon: Plus, to: '/training/new', permission: 'training.create', order: 20 }],
  slots: { 'coach.dashboard.operations': [{ id: 'upcoming-training', order: 10, permission: 'training.view', component: CoachTrainingCard }] },
  access: {
    title: 'Training', order: 35,
    levels: [
      { id: 'viewer', label: 'Viewer', description: 'See training calendars, sessions and participation.', perms: ['training.view', 'training_participation.view'] },
      { id: 'coach', label: 'Coach', description: 'Plan, edit, cancel and complete training and record participation.', perms: ['training.create', 'training.edit', 'training.cancel', 'training.complete', 'training_participation.manage'] },
    ],
    extras: [{ id: 'notes', label: 'Coach notes', description: 'See and write coach-only training notes.', perms: ['training_notes.view', 'training_notes.manage'] }],
    permissions: {
      'training.view': 'See training sessions, calendars and history', 'training.create': 'Create and duplicate training sessions',
      'training.edit': 'Edit scheduled training sessions', 'training.cancel': 'Cancel training sessions', 'training.complete': 'Complete and reopen training sessions',
      'training_participation.view': 'See actual training participation', 'training_participation.manage': 'Record actual training participation',
      'training_notes.view': 'See coach training notes', 'training_notes.manage': 'Write coach training notes',
    },
  },
};
